module.exports = __webpack_public_path__ + "media/images/shark/SharkUnderwater-e4881a577e2bcf3be65629c5c76e9668.jpg";